import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import EventAllListContainer from '../../views/event/all/EventAllListContainer';
import { EVENT_PAGE_NAME } from '../../constants/service/app/eventConstants';

const EventAllList = () => {
  return (
    <PageTemplate pageName={EVENT_PAGE_NAME.EVENT_ALL_LIST}>
      <EventAllListContainer />
    </PageTemplate>
  );
};

export default EventAllList;
